@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div class="flex flex-col justify-center items-center h-full gap-4xl">
    @if (!isSuccessScreen()) {
      <div class="flex flex-col gap-md justify-center items-center">
        <svg
          width="70"
          height="70"
          class="size-17 text-primary-500"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.4"
            d="M47.2208 5.83337H22.7791C12.1624 5.83337 5.83325 12.1625 5.83325 22.7792V47.1917C5.83325 57.8375 12.1624 64.1667 22.7791 64.1667H47.1916C57.8083 64.1667 64.1374 57.8375 64.1374 47.2209V22.7792C64.1666 12.1625 57.8374 5.83337 47.2208 5.83337Z"
            fill="currentColor" />
          <path
            d="M45.2084 29.5459C48.2368 29.5459 50.6918 27.0909 50.6918 24.0626C50.6918 21.0342 48.2368 18.5792 45.2084 18.5792C42.1801 18.5792 39.7251 21.0342 39.7251 24.0626C39.7251 27.0909 42.1801 29.5459 45.2084 29.5459Z"
            fill="currentColor" />
          <path
            d="M24.7917 29.5459C27.82 29.5459 30.275 27.0909 30.275 24.0626C30.275 21.0342 27.82 18.5792 24.7917 18.5792C21.7633 18.5792 19.3083 21.0342 19.3083 24.0626C19.3083 27.0909 21.7633 29.5459 24.7917 29.5459Z"
            fill="currentColor" />
          <path
            d="M45.5001 37.6833H24.5001C22.4584 37.6833 20.7959 39.3458 20.7959 41.4167C20.7959 49.2625 27.1834 55.65 35.0292 55.65C42.8751 55.65 49.2626 49.2625 49.2626 41.4167C49.2334 39.375 47.5417 37.6833 45.5001 37.6833Z"
            fill="currentColor" />
        </svg>

        <h4 class="text-3xl font-extrabold">
          {{ 'create_password_screen_title' | transloco }},
          {{ userData().name }}!
        </h4>

        <p class="font-medium text-sm text-neutral-500">
          {{ 'create_password_screen_sub_title' | transloco }}
        </p>
      </div>
    }
    <div class="bg-white py-5xl px-2xl rounded-xl">
      <form [formGroup]="createPasswordForm()" class="create-form">
        <div>
          <h5 class="text-2xl font-semibold mb-md text-neutral-900">
            {{ 'reset_password_screen_reset_password_header' | transloco }}
          </h5>

          <p class="mb-sm font-medium text-sm text-neutral-500">
            {{
              'create_password_screen_set_up_password_sub_header' | transloco
            }}
          </p>
        </div>

        <div class="flex flex-col my-4xl gap-lg">
          <div class="w-full">
            <lib-input
              [label]="
                'change_password_screen_current_password_label' | transloco
              "
              [placeholder]="
                'change_password_screen_current_password_placeholder'
                  | transloco
              "
              id="current_password"
              inputFormControlName="current_password"
              [startIconTemplate]="lockIconTemplate"
              [endIconTemplate]="
                !showCurrentPassword ? eyeIconTemplate : eyeHiddenIconTemplate
              "
              (endIconCLick)="showCurrentPassword = !showCurrentPassword"
              [type]="showCurrentPassword ? 'text' : 'Password'"
              inputClass="placeholder:text-sm"
              name="current_password" />

            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="current_password" />
          </div>

          <div class="w-full">
            <lib-input
              [label]="'reset_password_screen_new_password_label' | transloco"
              [placeholder]="
                'create_password_screen_create_password_placeholder' | transloco
              "
              id="Password"
              inputFormControlName="new_password"
              [startIconTemplate]="lockIconTemplate"
              [endIconTemplate]="
                !showPassword ? eyeIconTemplate : eyeHiddenIconTemplate
              "
              (endIconCLick)="showPassword = !showPassword"
              [type]="showPassword ? 'text' : 'Password'"
              inputClass="placeholder:text-sm"
              name="new_password" />
          </div>

          <div class="w-full">
            <lib-input
              [label]="
                'create_password_screen_confirm_password_label' | transloco
              "
              [placeholder]="
                'create_password_screen_confirm_password_placeholder'
                  | transloco
              "
              id="password_confirmation"
              inputFormControlName="new_password_confirmation"
              [startIconTemplate]="lockIconTemplate"
              [endIconTemplate]="
                !showConfirmationPassword
                  ? eyeIconTemplate
                  : eyeHiddenIconTemplate
              "
              (endIconCLick)="
                showConfirmationPassword = !showConfirmationPassword
              "
              [type]="showConfirmationPassword ? 'text' : 'Password'"
              inputClass="placeholder:text-sm"
              name="new_password_confirmation"></lib-input>
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="new_password_confirmation"></lib-validation-message>
          </div>
        </div>

        <div class="password-validation mt-lg mb-4xl">
          <div
            [class.valid]="passwordValidationStatus.length"
            [class.invalid]="
              !passwordValidationStatus.length &&
              passwordValidationStatus.touched
            ">
            {{ 'create_password_screen_password_requirement_1' | transloco }}
          </div>
          <div
            [class.valid]="passwordValidationStatus.upperCase"
            [class.invalid]="
              !passwordValidationStatus.upperCase &&
              passwordValidationStatus.touched
            ">
            {{ 'create_password_screen_password_requirement_2' | transloco }}
          </div>
          <div
            [class.valid]="passwordValidationStatus.lowerCase"
            [class.invalid]="
              !passwordValidationStatus.lowerCase &&
              passwordValidationStatus.touched
            ">
            {{ 'create_password_screen_password_requirement_3' | transloco }}
          </div>
          <div
            [class.valid]="passwordValidationStatus.number"
            [class.invalid]="
              !passwordValidationStatus.number &&
              passwordValidationStatus.touched
            ">
            {{ 'create_password_screen_password_requirement_4' | transloco }}
          </div>
          <div
            [class.valid]="passwordValidationStatus.specialChar"
            [class.invalid]="
              !passwordValidationStatus.specialChar &&
              passwordValidationStatus.touched
            ">
            {{ 'create_password_screen_password_requirement_5' | transloco }}
          </div>
        </div>

        <lib-button
          [id]="'reset-password'"
          [label]="'reset_password_screen_reset_password_button' | transloco"
          [disabled]="
            !createPasswordForm().get('new_password')?.value?.trim() ||
            !createPasswordForm().get('new_password_confirmation')?.value ||
            !createPasswordForm().valid ||
            isDisabled
          "
          (click)="resetPassword()"
          [btnClass]="
            'create-btn rounded-md py-sm px-2xl bg-primary-500 w-full text-white text-lg mb-2xl  font-medium'
          "></lib-button>
      </form>
    </div>
  </div>
}

<ng-template #lockIconTemplate>
  <lib-lock-icon [iconClass]="'size-5 text-neutral-900'" />
</ng-template>

<ng-template #eyeIconTemplate>
  <lib-view-icon [iconClass]="'size-5 text-neutral-900'" />
</ng-template>

<ng-template #eyeHiddenIconTemplate>
  <lib-eye-hidden-icon [iconClass]="'size-5 text-neutral-900'" />
</ng-template>
